function state() {
  return {
    policies: [],
    policy: {},
    claims: [],
    claim: {},
    policiesMeta: {},
    claimsMeta: {},
    claimsHistoriesClaim: {},
    partners: [],
    products: [],
    productCategories: [],
    uploadProgress: 0,
    createPolicy: {},
    createClaim: [],
    questionCostEstimation: [],
    filesCostEstimation: [],
    extractImei: "",
    isValidCreateClaim: {},
    productService: [],
    productServiceBuybackProgram: false,
    listBrand: [],
    listType: [],
    templateUrl: {},
  };
}

export default state;
